import React, { useEffect, useState } from "react";
import { Button, Modal, Backdrop, Fade } from "@mui/material";
import Grid from "@mui/material/Grid";
import successImg from "../../imgs/succes.svg";

const SuccessRole = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className="mx-3"
    >
      <Fade in={open}>
        <div className="modal-container">
          {" "}
          {/* CSS class for centering */}
          <div className="modal-content assign-modal px-4">
            <div className="d-flex justify-content-center">
              <img
                src={successImg}
                alt="success"
                width="68"
                height="68"
                className="my-4"
              />
            </div>
            {/* Modal content goes here */}
            <p className="modal-head mb-0">Role Added Successfully</p>
            <p className="modal-subhead">
              You have successfully added a new role.
            </p>

            <Grid container spacing={2} className="mt-1">
              <Grid item xs={12}>
                <Button
                  type="button"
                  variant="contained"
                  className="submit-btn mt-1 mt-md-3 mb-3"
                  onClick={() => onClose()}
                >
                  Continue
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default SuccessRole;
